import 'bootstrap'
import jQuery from 'jquery'

// @ts-ignore
window.$ = window.jQuery = jQuery

export {}
